export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface LogMessage {
  level: LogLevel;
  message: string;
  timestamp: Date;
  context?: Record<string, any>;
}

export interface LogDestination {
  log: (entry: LogMessage) => void | Promise<void>;
}

export class Logger {
  private destinations: LogDestination[] = [];

  constructor(destinations: LogDestination[] = []) {
    this.destinations = destinations;
  }

  addDestination(destination: LogDestination) {
    this.destinations.push(destination);
  }

  log(level: LogLevel, message: string, context?: Record<string, any>) {
    const entry: LogMessage = {
      level,
      message,
      timestamp: new Date(),
      context,
    };

    for (const destination of this.destinations) {
      destination.log(entry);
    }
  }

  debug(msg: string, context?: Record<string, any>) {
    this.log('debug', msg, context);
  }

  info(msg: string, context?: Record<string, any>) {
    this.log('info', msg, context);
  }

  warn(msg: string, context?: Record<string, any>) {
    this.log('warn', msg, context);
  }

  error(msg: string, context?: Record<string, any>) {
    this.log('error', msg, context);
  }
}
